import { render, staticRenderFns } from "./ManageUsersTabs.vue?vue&type=template&id=064c412c&"
import script from "./ManageUsersTabs.vue?vue&type=script&lang=js&"
export * from "./ManageUsersTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports